import React from 'react';
import { validateParam } from 'shared/utils/url';
import { listCurrencyCodes } from 'constants/currencies';
import { listLocaleCodes } from 'constants/locales';

const initialize = (field: string, fallback: string, collection: string[]) => {
  const searchParams = new URLSearchParams(window.location.search);

  return (
    validateParam(searchParams.get(field), collection, fallback) ||
    validateParam(window.localStorage.getItem(field), collection, fallback) ||
    fallback
  );
};

export interface GlobalState {
  currency: string;
  locale: string;
}

export type ActionType = 'SET_CURRENCY' | 'SET_LOCALE' | 'CLOSE_COOKIE_BANNER';

type GlobalContext = [
  GlobalState,
  React.Dispatch<{ type: ActionType; payload: unknown }>
];

const defaultLocale = window['wl_config']?.['defaultLocale'];
const enabledLocales = window['wl_config']?.['enabledLocales'] || [];

// allow only values from enabledLocales or default country codes
const countryCodes =
  enabledLocales.length > 0
    ? listLocaleCodes().filter(code => enabledLocales.includes(code))
    : listLocaleCodes();

export const initialState: GlobalState = {
  currency: initialize('currency', 'EUR', listCurrencyCodes()),
  locale: initialize(
    'locale',
    defaultLocale || countryCodes[0] || 'en',
    countryCodes
  ),
};

export const GlobalStateContext = React.createContext<GlobalContext>([
  initialState,
  () => null,
]);
